import "./WrappedTooltip.css";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Tooltip from "../tooltip/index";
import styled from "styled-components/macro";

import { WithTranslation, withTranslation } from "react-i18next";

import { parseISO } from "date-fns";

import { EDITBOX_BORDER } from "../../helpers/Const";
import { formatWithLocale as format } from "../../helpers/DateHelpers";

import { translatePropertyDefName, translateValueListItemName } from "../../../backend/helpers/translationHelpers";

import { isOwnProperty, getPropertyId } from "../../../backend/helpers/configurationHelpers";

import { PropertyDataType } from "../../../backend/constants/datatypes";

import { FlexItem, SettingsPanelContainerRow } from "../common/StyledComponents";
import { IconSettingsButton22x22 } from "../common/Buttons";

import editTaskIcon from "../../../icons/IconTooltipEdit.png";
import editTaskIconHover from "../../../icons/IconTooltipEditHover.png";
import editTaskIconPressed from "../../../icons/IconTooltipEditPressed.png";
import removeTaskIcon from "../../../icons/IconTooltipDelete.png";
import removeTaskIconHover from "../../../icons/IconTooltipDeleteHover.png";
import removeTaskIconPressed from "../../../icons/IconTooltipDeletePressed.png";
import mfLinkIcon from "../../../icons/mfilink.png";
import { VINCITEAM_URLSEARCHOBJECT } from "src/backend/constants/common";
import { Dispatch, iRootState } from "src/rematch/store";
import { AxiosInstance } from "axios";
import { IOwnPropertyOrId } from "src/backend/interfaces/configuration/IConfiguration";
import IMFilesPropertyDefinition from "src/backend/interfaces/mfiles/IMFilesPropertyDefinition";
import IMfilesValueListDefinition from "src/backend/interfaces/mfiles/IMFilesValueListDefinition";
import { Action } from "@rematch/core";
import { IItem, IItemProperty } from "src/backend/interfaces/IItem";

const imgs = [editTaskIcon, editTaskIconHover, editTaskIconPressed, removeTaskIcon, removeTaskIconHover, removeTaskIconPressed];

export const TooltipRoot = styled.div`
  border: 1px solid ${EDITBOX_BORDER};
  background: white;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 5px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

interface IEditButtonsRootProps {
  top: number;
}

const EditButtonsRoot = styled.div.attrs((props: IEditButtonsRootProps) => ({
  style: { top: props.top },
}))`
  display: flex;
  align-items: center;
  align-self: center;
  padding: 5px;
`;

const TooltipColumnsOuter = styled.table`
  border-collapse: collapse;
`;

const TooltipColumnsInner = styled.tbody`
  font-family: Segoe UI;
  font-size: 12px;
`;

const TooltipColumn = styled.tr`
`;

const TooltipColumnHeader = styled.td`
  text-align: right;
  vertical-align: top;
  font-weight: bold;
`;

const TooltipColumnValue = styled.td`
  vertical-align: top;
  padding-left: 5px;
`;

interface ITooltipContentProps extends WithTranslation {
  httpClient: AxiosInstance;
  getTooltipProperties: (objectType: number) => IOwnPropertyOrId[];
  getPropertyDefinition: (propertyId: number) => IMFilesPropertyDefinition;
  getValueListDefinition: (valueListId: number) => IMfilesValueListDefinition;
  getUrlSearchObjectPropertyId: () => number;
  allowAddAndEdit: boolean;
  isEditAllowed: (objectType: number) => boolean;
  dateFormat: string;
  timeFormat: string;
  showTimeInTable: boolean;
  vaultGuid: string;
  mfilesLinkType: string;
  mfilesApiBaseUrl: string;
  task: IItem;

  showEditBox: () => Action<void,void>;
  selectItem: (taskId: number) => Action<number,void>;
}

class TooltipContent extends PureComponent<ITooltipContentProps> {
  componentDidMount = () => {
    for (const imgURL of imgs) {
      const img = new Image();
      img.src = imgURL;
    }
  };

  showEditBox = () => {
    this.props.selectItem(this.props.task.id);
    this.props.showEditBox();
  };

  mFilesLink = () => {
    const vaultGuid = this.props.vaultGuid.replace("{","").replace("}","");
    const objectGuid = this.props.task.objectGuid.replace("{","").replace("}","");
    
    switch(this.props.mfilesLinkType) {
      case "desktop":
        return `m-files://show/${vaultGuid}/${this.props.task.objectType}-${this.props.task.objectId}`;
      case "desktopmetadatacard":
        return `m-files://showmetadata/${vaultGuid}/${this.props.task.objectType}-${this.props.task.objectId}`;
      case "vinciteam":
      {
        const urlSearcObjectProperty = this.props.getUrlSearchObjectPropertyId();
        return `m-files://search/${vaultGuid}?propertyvalue=${urlSearcObjectProperty}/Mopenobject-${this.props.task.objectType}-${this.props.task.objectId}`;
      }
      case "web":
        return `${this.props.mfilesApiBaseUrl}/Default.aspx#${vaultGuid}/object/${objectGuid}/latest`;
      case "webmetadatacard":
        return `${this.props.mfilesApiBaseUrl}/MetadataCard.aspx#${vaultGuid}/object/${objectGuid}/latest`;
      default:
        return null;
    }
  }

  openInMFiles = () => {
    const url = this.mFilesLink();
    if(url) {
      if(url.startsWith("m-files")) {
        document.location.href = url;
      } else {
        window.open(url);
      }
    }
  }

  renderEditBox = () => {
    return (
      <EditButtonsRoot>
        <SettingsPanelContainerRow>
          {this.props.allowAddAndEdit && ( !this.props.task.isCheckedOut || this.props.task.isCheckedOutToThisUser ) && this.props.isEditAllowed(this.props.task.objectType) ? (
            <FlexItem>
              <IconSettingsButton22x22
                onClick={() => this.showEditBox()}
                image={editTaskIcon}
                imageHover={editTaskIconHover}
                imagePressed={editTaskIconPressed}
              />
            </FlexItem>
          ) : null}
          {this.props.mfilesLinkType ? (
            <FlexItem>
              <IconSettingsButton22x22
                onClick={this.openInMFiles}
                image={mfLinkIcon}
                imageHover={mfLinkIcon}
                imagePressed={mfLinkIcon}
              />
            </FlexItem>
          ) : null}
        </SettingsPanelContainerRow>
      </EditButtonsRoot>
    );
  };

  getDateFormat() {
    return this.props.dateFormat + (this.props.showTimeInTable ? " " + this.props.timeFormat : "");
  }

  getOwnProperty(propertyName: string) {
    const { t } = this.props;
    const translationKey = `property.${propertyName}`;
    let translationText = t(translationKey);
    if(translationText === translationKey) {
      translationText = propertyName;
    }
    let field = this.props.task[propertyName];
    if (field instanceof Date) {
      field = format(field, this.getDateFormat());
    }
    return [translationText, field];
  }

  getPropertyValue(property: IItemProperty) {
    const { t } = this.props;
    if( !property || property.value === null || property.value === undefined || property.value === "" ) {
      return "";
    }
    switch(property.dataType) {
      case PropertyDataType.Boolean:
        return property.value ? t("boolean.true") : t("boolean.false");
      case PropertyDataType.Date:
        //remove trailing Z
        return format(parseISO(property.value.slice(0, -1)), this.props.dateFormat);
      case PropertyDataType.Time:
        //remove trailing Z
        return format(parseISO(property.value.slice(0, -1)), this.props.timeFormat);
      case PropertyDataType.Lookup:
      case PropertyDataType.MultiSelectLookup: {
        const propertyDefinition = this.props.getPropertyDefinition(property.property);
        if(propertyDefinition && propertyDefinition.BasedOnValueList && propertyDefinition.ValueList !== null) {
          const valueListDefinition = this.props.getValueListDefinition(propertyDefinition.ValueList)
          if(valueListDefinition) {
            const propertyValues = property.value.split(",");
            const displayValues = property.displayValue.split(";");
            const translatedValues = [];
            for(let i = 0; i < propertyValues.length; i++) {
              const translatedValue = translateValueListItemName(propertyDefinition.ValueList, parseInt(propertyValues[i]), displayValues[i]);
              translatedValues.push(<div key={i}>{translatedValue}</div>);
            }
            return translatedValues;
          }
        }
        return property?.displayValue ?? "";
      }
      default:
        return property?.displayValue ?? "";
    }
  }

  getProperty(propertyId: number) {
    const property = this.props.task.properties.find((p) => p.property === propertyId);
    const propertyDef = this.props.getPropertyDefinition(propertyId);
    const propertyName = translatePropertyDefName(propertyId, propertyDef.Name);
    const propertyValue = this.getPropertyValue(property);
    return [propertyName, propertyValue];
  }

  renderProperties(properties) {
    const fieldData = [];
    let i = 0;
    for(const propertyId of properties) {
      let propertyName;
      let propertyValue;
      if(isOwnProperty(propertyId.toString())) {
        [propertyName, propertyValue] = this.getOwnProperty(propertyId.toLowerCase());
      } else {
        [propertyName, propertyValue] = this.getProperty(propertyId);
      }
      fieldData.push(      
        <TooltipColumn key={i++}>
          <TooltipColumnHeader>{propertyName}:</TooltipColumnHeader>
          <TooltipColumnValue>{propertyValue}</TooltipColumnValue>
        </TooltipColumn>
      );
    }
    return (
      <TooltipColumnsOuter>
        <TooltipColumnsInner>{fieldData}</TooltipColumnsInner>
      </TooltipColumnsOuter>);
  }

  render() {

    //Use external configuration
    let tooltipProperties = this.props.getTooltipProperties(this.props.task.objectType);

    //Fallback to UI settings
    if(!tooltipProperties?.length) {
      tooltipProperties = ["name", "start", "end"];
    }
    
    return (
      <TooltipRoot>
        {this.renderProperties(tooltipProperties)}
        {this.renderEditBox()}
      </TooltipRoot>
    );
  }
}

interface IWrappedTooltipProps extends ITooltipContentProps {
  dragUnderway: boolean;
  children?: JSX.Element | JSX.Element[];
}

const WrappedTooltip = (props: IWrappedTooltipProps) => {
  const content = <TooltipContent {...props}></TooltipContent>;
  return (
    <Tooltip
      content={content}
      tipContentHover={true}
      mouseOutDelay={500}
      hoverDelay={500}
      arrow={false}
      direction="right" //Note: this setting doesn't seem to work. I might have done some adjustments in my fork of this lib. See package.json and react-tooltip-lite.
      isOpen={props.dragUnderway ? false : undefined}
      className="tooltip-wrapper"
      useDefaultStyles={false}
      maxMouseDistance={50}
    >
      {props.children}
    </Tooltip>
  );
};

const mapState = (state: iRootState) => ({
  httpClient: state.common.httpClient,
  getTooltipProperties: (objectType: number) => state.common.configuration.objectTypeConfigurations.get(objectType).tooltip,
  getPropertyDefinition: (propertyId: number) => state.common.configuration.propertyDefinitions.get(propertyId),
  getValueListDefinition: (valueListId: number) => state.common.configuration.valueListDefinitions.get(valueListId),
  getUrlSearchObjectPropertyId: () => getPropertyId(state.common.configuration.aliasConfiguration, VINCITEAM_URLSEARCHOBJECT),
  //tooltipColumns: state.UI.displaySettings.tooltipColumns,
  allowAddAndEdit: state.UI.displaySettings.allowAddAndEdit,
  isEditAllowed: (objectType: number) => state.common.configuration.objectTypeConfigurations.get(objectType).mayEdit,
  dateFormat: state.UI.displaySettings.dateFormat,
  timeFormat: state.UI.displaySettings.timeFormat,
  showTimeInTable: state.UI.displaySettings.showTimeInTable,
  vaultGuid: state.common.configuration.vaultGuid,
  mfilesLinkType: state.common.configuration.mfilesLinkType,
  mfilesApiBaseUrl: state.common.configuration.mfilesApiBaseUrl,
});
const mapDispatch = (dispatch: Dispatch) => ({
  showEditBox: dispatch.UI.showEditBox,
  selectItem: dispatch.items.selectItem,
});
export default withTranslation()(connect(mapState, mapDispatch)(WrappedTooltip));
